<template>
  <div class="p-4 mt-4">
    <!-- <div class="row">
      <div
        v-for="(card, index) in cards"
        :key="index"
        class="col-12 col-sm-6 col-md-3"
      >
        <div class="card p-3 text-white shadow">
          <div class="d-flex justify-content-between">
            <div>
              <p
                class="text-dark m-0"
                style="font-size: 13px; font-weight: 600"
              >
                {{ card.title }}
              </p>
              <h6>
                {{ card.value }}
                <span :class="card.changeColor">({{ card.change }})</span>
              </h6>
              <p class="text-muted" style="font-size: 13px">
                {{ card.description }}
              </p>
            </div>

            <div>
              <span
                class="p-2 rounded"
                :style="{ backgroundColor: `${card.bgColor}` }"
              >
                <i
                  :class="card.icon"
                  :style="{ color: card.iconColor }"
                  class="fa fa-x"
                ></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div >
      <div class="row">
        <div class="col-12">
          <div class="card invoice p-0">
            <!-- <h5 class="mx-2 pb-0 pl-4 pt-4">Filter</h5> -->

            <!-- Card header -->
            <div
              class="d-lg-flex justify-content-between align-items-center mx-2 pb-0 card-header invoice"
            >
              <!-- <div class="d-flex align-items-center" style="gap: 20px"> -->
                <h5 >Pop Elc Down Log</h5>
                <!-- <select name="" id="" class="form-control" style="width: 180px">
                  <option value="" selected disabled>Select Role</option>
                </select>
                <select name="" id="" class="form-control" style="width: 180px">
                  <option value="" selected disabled>Select Plan</option>
                </select>
                <select name="" id="" class="form-control" style="width: 180px">
                  <option value="" selected disabled>Select Status</option>
                </select> -->
              <!-- </div> -->
              <div class="d-flex gap-3">
                <div class="flex-grow-1">
                  <input
                    type="text"
                    v-model="searchQuery"
                    class="form-control invoice"
                    placeholder="Search..."
                  />
                </div>
                <div class="">
                  <button
                    @click="openAddForm"
                    class="bg-success btn text-white rounded py-0"
                    :style="{ height: '35px' }"
                  >
                    Add New
                  </button>
                </div>
              </div>
            </div>
            <div class="px-0 pb-0 card-body">
              <!-- Table -->
              <!-- <div class="table-responsive" v-if="filteredUsers?.length > 1"> -->
                <div class="card mb-4">
                  <div class="card-body px-0 pt-0 pb-2 invoice">
                    <div class="table-responsive p-0" v-if="data && data.length > 0">
                      <table class="table align-items-center mb-0">
                        <thead>
                        <tr>
                          <th                            
                            class="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            SI
                          </th>                          
                          <th
                            @click="sort('downtime')"
                            :class="{
                              asc: sortKey === 'downtime' && sortOrder === 'asc',
                              desc: sortKey === 'downtime' && sortOrder === 'desc',
                            }"
                            class="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Down Time
                          </th>
                          
                          <th
                            @click="sort('uptime')"
                            :class="{
                              asc: sortKey === 'uptime' && sortOrder === 'asc',
                              desc: sortKey === 'uptime' && sortOrder === 'desc',
                            }"
                            class="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Up Time
                          </th>
                          <th
                            @click="sort('ip_addr')"
                            :class="{
                              asc: sortKey === 'ip_addr' && sortOrder === 'asc',
                              desc: sortKey === 'ip_addr' && sortOrder === 'desc',
                            }"
                            class="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Ip
                          </th>
                          
                          <th
                            @click="sort('downtime_time')"
                            :class="{
                              asc: sortKey === 'downtime_time' && sortOrder === 'asc',
                              desc: sortKey === 'downtime_time' && sortOrder === 'desc',
                            }"
                            class="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Down
                          </th>
                          <th
                            @click="sort('uptime_time')"
                            :class="{
                              asc: sortKey === 'uptime_time' && sortOrder === 'asc',
                              desc: sortKey === 'uptime_time' && sortOrder === 'desc',
                            }"
                            class="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Up
                          </th>
                          
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in paginatedData" :key="index">
                          <td>{{ index+1 }}</td>
                          <td>{{ item.downtime }} min</td>
                          <td>{{ item.uptime }}</td>
                          <td>{{ item.ip_addr }}</td>                          
                          <td> <soft-badge class="bg-danger px-1 rounded-1 text-white cursor-pointer text-xs mx-3" variant="gradient" size="sm">Down</soft-badge> {{ item.downtime_time }}</td>
                          <td> <soft-badge class="bg-success px-1 rounded-1 text-white cursor-pointer text-xs mx-3" variant="gradient" size="sm">Up</soft-badge> {{ item.uptime_time }}</td>
                        </tr>
                      </tbody>
                      </table>
                    </div>
                    <div v-else>
                      <p>No Logs available. Please add one.</p>
                    </div>
                  </div>
                </div>
              <!-- </div> -->
              <!-- <div v-else>
                <Skalaton />
              </div> -->
            </div>

            <!-- <div class="d-flex justify-content-end align-items-center">
              <div class="">
                <button
                  class="btn btn-sm btn-success mx-3 mt-3"
                  @click="previousPage"
                  :disabled="currentPage === 1"
                >
                  Previous
                </button>
                <span class="mx-2"
                  >Page {{ currentPage }} of {{ totalPages }}</span
                >
                <button
                  class="btn btn-sm btn-success mx-3 mt-3"
                  @click="nextPage"
                  :disabled="currentPage === totalPages"
                >
                  Next
                </button>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <!-- Sliding Panel -->
      <!-- <div class="form-panel" :class="{ 'is-open': isFormPanelOpen }">
        <div class="form-header">
          <h5 v-if="isEditing">Edit User</h5>
          <h5 v-else>Add New User</h5>
          <span @click="toggleFormPanel" class="item">
            <Close />
          </span>
        </div>
        <form
          @submit.prevent="saveUser"
          class="d-flex flex-column"
          style="gap: 10px"
        >
          <div>
            <label class="form-label">Username</label>
            <input
              type="text"
              placeholder="Username"
              class="form-control invoice-card"
              v-model="form.user.username"
              required
            />
          </div>
          <div>
            <label class="form-label">Email</label>
            <input
              type="email"
              placeholder="Email"
              class="form-control invoice-card"
              v-model="form.user.email"
              required
            />
          </div>
          <div>
            <label class="form-label">Password</label>
            <input
              type="password"
              placeholder="Password"
              class="form-control invoice-card"
              v-model="form.user.password"
            />
          </div>
          <div>
            <label class="form-label">Contact Number</label>
            <input
              type="text"
              placeholder="Contact Number"
              class="form-control invoice-card"
              v-model="form.number"
            />
          </div>
          <div>
            <label class="form-label">Address</label>
            <input
              type="text"
              placeholder="Address"
              class="form-control invoice-card"
              v-model="form.address"
            />
          </div>
          <div>
            <label class="form-label">Branch</label>
            <select class="form-control bg" v-model="form.zones" multiple>
              <option
                v-for="(data, index) in branches"
                :key="index"
                :value="data.id"
              >
                {{ data.name }}
              </option>
            </select>
          </div>

          <div>
            <label class="form-label">ISP Name</label>
            <input
              type="text"
              placeholder="ISP Name"
              class="form-control invoice-card"
              v-model="form.isp_name"
            />
          </div>
          <div>
            <label class="form-label">Role</label>
            <select class="form-control bg" v-model="form.user_role">
              <option value="" selected disabled>Select Role</option>
              <option
                v-for="(data, index) in roles"
                :key="index"
                :value="data.id"
              >
                {{ data.name }}
              </option>
            </select>
          </div>
          <div>
            <label class="form-label">Send Message</label>
            <input type="checkbox" class="mx-1 mt-1" v-model="form.send_msg" />
          </div>
          <div class="mt-4">
            <button type="submit" class="btn btn-success">
              {{ isEditing ? "Update" : "Save" }}
            </button>
          </div>
        </form>
      </div> -->
    </div>
  </div>
</template>

<script>
import { useElcMonitorApi } from '@/services/elc-monitor.service';

export default {
  data() {
    return {
      data: [], 
      
      filteredData: [], 
      searchQuery: '',
      loading: false,
      sortKey: '',
      sortOrder: '',
      cards: [
        {
          title: "Session",
          value: "21,459",
          change: "+29%",
          changeColor: "text-success",
          description: "Total Users",
          icon: "fa fa-users",
          iconColor: "purple",
          bgColor: "rgba(128, 0, 128, 0.1)",
        },
        {
          title: "Paid Users",
          value: "4,567",
          change: "+18%",
          changeColor: "text-success",
          description: "Last Week Analytics",
          icon: "fa fa-user-plus",
          iconColor: "red",
          bgColor: "rgba(255, 0, 0, 0.1)",
        },
        {
          title: "Active Users",
          value: "19,860",
          change: "-14%",
          changeColor: "text-danger",
          description: "Last Week Analytics",
          icon: "fa fa-user-check",
          iconColor: "green",
          bgColor: "rgba(0, 128, 0, 0.1)",
        },
        {
          title: "Pending Users",
          value: "237",
          change: "+42%",
          changeColor: "text-success",
          description: "Last Week Analytics",
          icon: "fa fa-user-clock",
          iconColor: "yellow",
          bgColor: "rgba(255, 255, 0, 0.1)",
        },
      ],
    };
  },
  computed: {
    paginatedData() {
      return this.filteredData; // Add pagination logic if needed
    },
  },
  methods: {
    
    async fetchLogData() {
      try {
        const response = await useElcMonitorApi().getLogList();  
       this.data = response;
        this.filteredData = this.data;
      } catch (error) {
        console.error("Error fetching Log data:", error);
      }
    },
    sort(column) {
      if (this.sortKey === column) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortKey = column;
        this.sortOrder = 'asc';
      }
      this.filteredData.sort((a, b) => {
        const valA = a[column];
        const valB = b[column];
        if (this.sortOrder === 'asc') {
          return valA > valB ? 1 : -1;
        } else {
          return valA < valB ? 1 : -1;
        }
      });
    },
  },

   watch: {
            searchQuery(newValue) {
                this.filteredData = this.data.filter(item => {
                    for (let key in item) {
                        if (String(item[key]).toLowerCase().includes(newValue.toLowerCase())) {
                            return true;
                        }
                    }
                    return false;
                });
                this.currentPage = 1;
            }
        },
  mounted() { 
    this.fetchLogData();  
  },
};
</script>

<style scoped>
.card {
  border-radius: 10px;
}

.dark-mode .card {
  background-color: #061f3e;
}

.custom-dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  right: 0;
  background-color: white;
  min-width: 120px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  z-index: 1;
}

.dropdown-content a {
  color: #333;
  padding: 8px 12px;
  text-decoration: none;
  display: block;
  font-size: 14px;
  transition: background-color 0.2s;
}

.dropdown-content a:hover {
  background-color: #f5f5f5;
}

/* Show dropdown on hover */
.custom-dropdown:hover .dropdown-content {
  display: block;
}

/* Dark mode support */
.dark-mode .dropdown-content {
  background-color: #1a2234;
}

.dark-mode .dropdown-content a {
  color: #fff;
}

.dark-mode .dropdown-content a:hover {
  background-color: #2a3441;
}
</style>
